import { type FC } from "react";
import { Card, Stack } from "@mui/material";
import { LoadingScreen, PageContainer } from "@packsize/components";

import { ClosingTable } from "@/views/closing/closing-table";
import { AwaitingClosingContainer } from "@/views/closing/awaiting-closing-container";
import { ClosingMachineContainer } from "@/views/closing/closing-machine";
import { useDownstreamMachines } from "@/hooks/machines";

import { ClosingMachineCard } from "./closing-machine/closing-machine-card";

export const Closing: FC = () => {
	const { machines = [], isLoading } = useDownstreamMachines();

	if (machines.length === 0 && isLoading) {
		return <LoadingScreen />;
	}

	if (machines.length === 0) {
		return null;
	}

	if (machines.length === 1) {
		return (
			<PageContainer>
				<Stack direction="row" gap={2} sx={{ flexShrink: 0 }}>
					<Card sx={{ flex: 3 }}>
						<ClosingTable />
					</Card>
					<ClosingMachineCard machine={machines[0]} sx={{ boxShadow: "none" }} />
				</Stack>
				<Card
					sx={{ marginTop: 2, flex: 1, minHeight: 0, overflow: "hidden", display: "flex", flexDirection: "column" }}
				>
					<AwaitingClosingContainer />
				</Card>
			</PageContainer>
		);
	}

	return (
		<PageContainer>
			<Stack direction="row" gap={2} sx={{ height: "100%" }}>
				<Stack direction="column" gap={2} sx={{ flex: 2 }}>
					<Card sx={{ flexShrink: 0 }}>
						<ClosingTable />
					</Card>
					<Card sx={{ flex: 1, minHeight: 0, overflow: "hidden", display: "flex", flexDirection: "column" }}>
						<AwaitingClosingContainer />
					</Card>
				</Stack>
				<Stack sx={{ flex: 1 }}>
					<ClosingMachineContainer />
				</Stack>
			</Stack>
		</PageContainer>
	);
};
